import React from 'react';
import { AccentDialog } from "../../dialogs/AccentDialog";
import { t } from "../../services/HelperService";
import { AccentButton } from "../AccentButton";
import { usePosition } from "../AccentDisplay";
import AccentCodeEditor from "./AccentCodeEditor";

export const AccentCodeDlg = props => {

    const [code, setCode] = React.useState(props.code ?? '');

    const pos = usePosition("acc-code-edit-dlg");

    const handleClose = e => {

        props.onClose({ code: code });

    };
    const handleCancel = e => {

        props.onClose({ canceled: true });

    };

    const maxHeight = pos.toScreenHeight - 40;
    const maxWidth= pos.toScreenWidth - 70;

    return <AccentDialog        
        relativeWidth={d => d.width - 80}
        relativeHeight={d => d.height - 80}
        onClose={handleCancel}
        headerContent="Code Editor"
        actionsContent={[
            <AccentButton key="2" onClick={handleClose}>{t("application_strings.application.buttons.update")}</AccentButton>
        ]}
    >

        <div id="acc-code-edit-dlg">
            <AccentCodeEditor
                defaultValue={code}
                onChange={setCode}
                language="html"
                
                width={`${maxWidth}px`}
            />

        </div>


    </AccentDialog>;
}

